<template>
  <div  v-if='currentUser' class="hello">
    <h1 class="top-covering-title"> {{selectProduct(region,$route.params.worldname)}}</h1>
     <!-- <lottie-animation id="lottieWorldAnim"
      ref="anim"
      :animationData="require(`@/assets/lottie_worlds/${region}/${world}.json`)"
      :loop="true"/>-->

    <div  id="lottieWorldAnim" ref="animworld"/>

    <Sidebar :v-if="sideLoaded" :worldname="world" :statusState="statusState"/>
    <button class="l-pause" @click="lottiePause"><b-icon icon="pause" aria-hidden="true" variant="success"></b-icon></button>
    <button class="l-play" @click="lottiePlay"><b-icon icon="play" aria-hidden="true" variant="success"></b-icon></button>
  </div>
</template>

<script>
import Sidebar from  './sidebarcomp'
//import LottieAnimation from 'lottie-web-vue' // import lottie-web-vue
import worldNameMixin from '../shared_methods/worldname_mixin'
import Lottie from 'lottie-web';
import formattingMixin from '../shared_methods/formattingMixin';
import badgeSrcMixin from '../shared_methods/badgeSrcMixin'
import careersInfoMixin from '../shared_methods/careers_Info_Mixin';

//import gamificationMixin from '../shared_methods/gamificationMixin';
import { mapActions,mapGetters,} from 'vuex'

let unsubscribe;
const delay = 1000; // anti-rebound for 500ms

let lastToastExecution = 0;
let lastToastExecutionFullWorld = 0;
let lastBadgeExecution=0;
export default {
  name: 'WorldHome',
  mixins: [worldNameMixin,formattingMixin,badgeSrcMixin,careersInfoMixin],

  props: {
    msg: String
  },

  data () {
   
    // eslint-disable-next-line no-unused-vars

      return {
                world:"",
                statusState:"",
                region:process.env.VUE_APP_CURRENT_REGION.toLowerCase(),
                animName: 'worldAnim',
              pauseAmbient:false,
              loaded:false,
              sideLoaded:false,
              

            }
  },
  computed: {
    ...mapGetters('user', ['currentUser']),
   // ...mapState('prog_tracking', ['world_info']),


  },
  methods: {
        ...mapActions('assessment', [ 'loginUser']),
           // ...mapActions('prog_tracking', ['getState', 'loginUser']),
    //...mapActions('awards_tracking', ['getAwardsState']),
    checkAllAchievementsAndMissions(){
      var pageStatus =  this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)]
      const achievements = pageStatus.complete_achievements
      const missions = pageStatus.complete_missions
      var allDone= (achievements.length>=2) && (missions.length>=5)
      console.log(achievements.length)
      console.log(missions.length)

      const badgeSrcInfo= this.selectBadgeSrc(process.env.VUE_APP_CURRENT_REGION.toLowerCase(),this.world)
      console.warn(badgeSrcInfo)
      if(allDone){
                                  //console.warn("ALL DONE")
     var achieveName= `${this.world}_ALLDONE` 
console.warn("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
console.log(this.statusState.badges)



        console.log(this.statusState.badges)
     const badgeAwarded=  this.statusState.badges.map(e => e.badgeName).indexOf(badgeSrcInfo) > -1;
     console.log(badgeSrcInfo)
                 if (badgeAwarded){
                    console.log("already")
                  }
                 else{
                  var toastExists = document.getElementById(achieveName)
          if (!toastExists){       
            if ((lastToastExecutionFullWorld + delay) < Date.now()){
      this.$bvToast.toast(`You Explored the Entire World! You Earned +50 Points! `, {
          title: `Achievement ALERT! `,
          variant: 'info',
          autoHideDelay: 5000,
          appendToast: true,
          id:achieveName
        })      
        lastToastExecutionFullWorld = Date.now() 

      }
    }
    var toastBadgeExists = document.getElementById(achieveName+"badge")
          if (!toastBadgeExists){       
            if ((lastBadgeExecution + delay) < Date.now()){
               const h = this.$createElement
        // Increment the toast count
    
        // Create the message
        const vNodesMsg = h(
          'b-img',
          { props: { src: require(`@/assets/badges/${badgeSrcInfo}-badge.png`) } 
          },
           
        )
        // Create the title
        const vNodesTitle = h(
          'div',
          { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
          [
            h('strong', { class: 'mr-2' }, 'BADGE ACQUIRED'),
            h('small', { class: 'ml-auto text-italics' }, '5 minutes ago')
          ]
        )
        // Pass the VNodes as an array for message and title
        this.$bvToast.toast([vNodesMsg], {
          title: [vNodesTitle],
          solid: true,
          autoHideDelay: 3400,
          appendToast: true,
          id:achieveName+"badge",
          variant: 'info'
        })
       
        this.$store.dispatch('conversations/setPointsAndMissionAcc',{
                  MISSION_OR_ACC_NAME:achieveName,
                  points:50,
                  MISSION_OR_ACC:"achieve",
                  docId:this.currentUser.id,
                  currentWorld:this.worldNameToDbNameFormat(this.world)




          });
          this.$store.dispatch('conversations/addBadge',{
                    badgeSrc:badgeSrcInfo,
                    badgeName:badgeSrcInfo,
                    docId:this.currentUser.id,
                    currentWorld:this.worldNameToDbNameFormat(this.world)

      
          })
          
      }
      lastBadgeExecution= Date.now() 
    }

      }
    }

    },
    checkAllVisits(){
      var pageStatus =  this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)]
      var newVisited = pageStatus.visitedSidebarElementName;
      console.log(newVisited);
      // Our fancy notification (2).
      if(

        (newVisited.indexOf('Explore') > -1)
        &&
        (newVisited.indexOf('Careers') > -1)
        &&
        (newVisited.indexOf('Education') > -1)
        &&
        (newVisited.indexOf('Employers') > -1)


      ){
        console.warn("awardedAlready")
        console.log(pageStatus)
        var achieveName=`${this.worldNameToDbNameFormat(this.world)}_VISITALL`
        const awardedAlready = pageStatus.complete_achievements.indexOf(achieveName) >-1;
 if ( newVisited.length >= 4 && !awardedAlready)
{      
  var toastExists = document.getElementById(achieveName)
  console.warn("pointsssss")
  console.warn("$$$$$$$$$$$$$$$$$&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&7")
  console.log(toastExists);

          if (toastExists === null){
            if ((lastToastExecution + delay) < Date.now()){

            this.$bvToast.toast(`You get  50 points for visiting all the sections! `, {
          title: `Achievement ALERT! `,
          variant: 'info',
          autoHideDelay: 5000,
          appendToast: true,
          id:achieveName
        })
        lastToastExecution = Date.now() 

console.warn(lastToastExecution)
      }
        }
        //this.stop=true
       
       
                  this.$store.dispatch('conversations/setPointsAndMissionAcc',{
                  MISSION_OR_ACC_NAME:achieveName,
                  points:50,
                  MISSION_OR_ACC:"achieve",
                  docId:this.currentUser.id,
                  currentWorld:this.worldNameToDbNameFormat(this.world)




          });
    
  
                 


                




      }

      }
      
},
    checkLearnAllCareers(){
      console.warn("$$$$$$$$$$$$$$$$DDDDDDDDDD$$$$$$$$$$$$$$$$$$$$$$$$$")
  console.warn("ALLCAREERS")
  const jobPageInfo = this.selectJobPageInfo(process.env.VUE_APP_CURRENT_REGION,this.world);
  const jobCount=  jobPageInfo.jobs.length
  // eslint-disable-next-line no-unused-vars
console.log(this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)].careersLearned)
console.log(jobCount)

      if(this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)].careersLearned.length >= jobCount){
        console.warn("$$DDDDDDDDDDDDDDDDDDDDDDDDDDDDD$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
  console.warn("ALLCAREERS")
   
      
  var achieveName= `${this.world}_ALLCAREERS`        


  const achievementsArray=   this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)].complete_achievements

  let achievementAwarded=achievementsArray.indexOf(achieveName)>-1;
                if (achievementAwarded){
                //  console.log("already has it")
                }
                else{
                  this.$store.dispatch('conversations/setPointsAndMissionAcc',{
                  MISSION_OR_ACC_NAME:achieveName,
                  points:50,
                  MISSION_OR_ACC:"achieve",
                  docId:this.currentUser.id,
                  currentWorld:this.worldNameToDbNameFormat(this.world)




          });
          var toastExists = document.getElementById(achieveName)
          if (!toastExists){
      this.$bvToast.toast(`You Learned About All Careers! You Earned +50 Points!`, {
          title: `Achievement Completed`,
          id:achieveName,
          autoHideDelay: 10000,
          appendToast: true
        })
          }
}
      }

    },
    checkLearn1Career(){

      var missionName= `${this.world}_LEARN1CAREER`
       const missionsArray=   this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)].complete_missions

       console.warn("learn1careers");
       console.log(missionsArray)
       console.log(missionName);
       console.log(this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)].careersLearned)
       if(this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)].careersLearned.length==0){
        return false
       }console.warn("$$$$$$$$$$$$$$$$$$$$$$$$$$SSSSSSSSS")
       console.log(missionsArray)
        let missionAwarded=missionsArray.indexOf(missionName)>-1;
          if(missionAwarded){
           //   console.log("mission already awarded")
            
          }
          else{
            var toastExists = document.getElementById(missionName)
          if (!toastExists){
               this.$bvToast.toast(`You Learned About a Career! You Earned +25 Points!`, {
                id:missionName,
          title: `Mission Accomplished`,
          autoHideDelay: 5000,
          appendToast: true
        })
          }
           console.log("currentuuser"+this.currentUser)


           this.$store.dispatch('conversations/setPointsAndMissionAcc',{
                  MISSION_OR_ACC_NAME:missionName,
                  points:25,
                  MISSION_OR_ACC:"mission",
                  docId:this.currentUser.id,
                  currentWorld:this.worldNameToDbNameFormat(this.world)




          });
    
  

          }      
    },
    checkAchievements(){
      this.checkLearn1Career();
      this.checkLearnAllCareers();
      this.checkAllVisits();
      this.checkAllAchievementsAndMissions();
    },
    statusChange(){
                var pageStatus =  this.statusState.worldsStatus[this.worldNameToDbNameFormat(this.world)]
                console.warn("changed")
          console.log(pageStatus)
          //alert(visitedPage)
          
          try {
            
            this.checkAchievements();
            this.$store.state.handheld =pageStatus
            if(pageStatus.pageVisited === undefined)
          {
          this.$store.dispatch('conversations/addProperty'
          , { 
          //text: this.newMessageText, 
          //created: Date.now(),

          docId: this.currentUser.id,
          property:"pageVisited",
          propertyValue:false,
          worldName:this.worldNameToDbNameFormat(this.world)
          //sender: this.$store.state.users.currentUser
          })

          }
          console.log(pageStatus)



          if (pageStatus.pageVisited === false)
          {//###LOOKHERE
                this.$store.dispatch('conversations/setPageVisit',{
                
                docId:this.currentUser.id,
                worldName:this.worldNameToDbNameFormat(this.world),


          });
          const missionName = `${this.world}_VISITWORLD`
          var toastExists = document.getElementById(missionName)
          if (!toastExists){
          this.$bvToast.toast(` You Visited : ${this.selectProduct(this.region,this.world)} World! You Earned +25 Points! `, {
          title: `Mission Completed`,
          autoHideDelay: 5000,
          appendToast: true,
          id:missionName

          })
        }

            console.log(`${this.world}_VISITWORLD`)
          this.$store.dispatch('conversations/setPointsAndMissionAcc',{
                  MISSION_OR_ACC_NAME:missionName,
                  points:25,
                  MISSION_OR_ACC:"mission",
                  docId:this.currentUser.id,
                  currentWorld:this.worldNameToDbNameFormat(this.world)




          });

                return    

          } 

          else{
         
                const badgeAwarded=  pageStatus.badges.map(e => e.badgeName).indexOf('persistence');
                //this.badgeAwarded(this.$store.state,{badgeSrc:"persistence",badgeName:"persistence"})
                 if (badgeAwarded){
                    console.log("already")
                  }
                 else{
                  this.$store.dispatch('conversations/addBadge',{
                    badgeSrc:"persistence",
                    badgeName:'persistence',
                    docId:this.currentUser.id,
                    currentWorld:this.worldname

      
      
      });
      this.$store.dispatch('conversations/setPointsAndMissionAcc',{
          MISSION_OR_ACC_NAME:"secret_persistence",
          points:100,
          MISSION_OR_ACC:"achieve",
          docId:this.currentUser.id,
          currentWorld:this.worldname,
          secret:true,



          });

          // Use a shorter name for this.$createElement
          const h2 = this.$createElement
          // Increment the toast count
          this.count++
          // Create the message
          const vNodesMsg2 = h2(
          'p',
          { class: ['text-center', 'mb-0'] },
            [
            h2('b-spinner', { props: { type: 'grow', small: true } }),
            ` persistence Pays: Visited Same World More Than Once +100 Points! `,
            h2('b-spinner', { props: { type: 'grow', small: true } })
          ]
          )
        // Create the title
        const vNodesTitle2 = h2(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h2('strong', { class: 'mr-2' }, 'SECRET ACHIEVEMENT'),
          h2('small', { class: 'ml-auto text-italics' }, '5 minutes ago')
        ]
        )
        // Pass the VNodes as an array for message and title
        this.$bvToast.toast([vNodesMsg2], {
        title: [vNodesTitle2],
        solid: true,
        autoHideDelay: 3500,
        appendToast: true,

        variant: 'info'
        })
        // Use a shorter name for this.$createElement
        const h = this.$createElement
        // Increment the toast count
        this.count++
        // Create the message
        const vNodesMsg = h(
        'b-img',
        { props: { src: require('@/assets/badges/persistence-badge.png') } 
        },
          
        )
        // Create the title
        const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h('strong', { class: 'mr-2' }, 'BADGE ACQUIRED'),
          h('small', { class: 'ml-auto text-italics' }, '5 minutes ago')
        ]
        )
        // Pass the VNodes as an array for message and title
        this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        autoHideDelay: 3400,
        appendToast: true,

        variant: 'info'
        })/*
                      this.$store.dispatch('prog_tracking/ADD_POINTS_DB',{
        points:100,currentUser:this.currentUser,currentWorld:this.world



        });
          
                              this.$store.dispatch('awards_tracking/ADD_SECRET_ACHIEVE_POINTS_DB',{
        achieveName:"persistence",
        currentUser:this.currentUser,currentWorld:this.world,

        points:100,

        });
        }*/
        }
      }
    }
          catch (e) {
          console.log("Error", e.stack);
          console.log("Error", e.name);
          console.log("Error", e.message);

          }


    },
    beforeDestroy() {
    this.hide = true;
    
    unsubscribe();
 
    // Destroys instance on exit
    Lottie.destroy(this.animName);
  },
  async testr()  {
    

          try {
            //console.log(this.currentUser)
              // this.test2(this.currentUser.id)
              console.warn("testr")
             //  var progress = await this.getState(this.currentUser)
               //               var awards=  await this.getAwardsState(this.currentUser)
                 //             this.progressStuff= progress 
                  //this.awardsStuff = awards
                  this.loaded=true
              console.log(this.progressStuff)

                  //console.log()
          } catch (err) {
            this.error=err
          //  this.$q.notify({
         //     message: `An error as occured: ${err}`,
         //     color: 'negative'
         //   })

          } finally {
            console.warn("INIT")
                                this.init();

           // this.$router.push({ path: '/dashboard' })
          }
      //  }
     // })
    },
        init() {
          console.log('init')
      // Grab the current world's animation data
      const animationData =  JSON.parse(JSON.stringify(require(`@/assets/lottie_worlds/${this.region}/${this.world}.json`)));

      this.anim = Lottie.loadAnimation({
        container: document.getElementById('lottieWorldAnim'), // TODO: Using Vue ref needs to be debugged
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
        name: this.animName
      });
    },
      lottiePause() {
        this.$refs.anim.pause() // .play, .pause, .stop available
      },  
      lottiePlay() {
        this.$refs.anim.play() // .play, .pause, .stop available
      },  
  
},
    created(){
    this.world = this.$route.params.worldname;


  },
  beforeMount(){
    console.log(this)
     const { currentUser } = this
    //console.log(currentUser)
    console.log(this)
    if (currentUser) {
      // Hide the loading screen if currentUser
      // is available before the page renders
      //this.$q.loading.hide()
      //this.getDataFromApi(this.currentUser.id)
      //console.log(currentUser)
         // this.init();
   
      //    if (this.pauseAmbient ==true)
      //    {
    //      this.$parent.$parent.restartAmbient()

     //     }
     unsubscribe = this.$fb.collectionRef('status').doc(currentUser.id).onSnapshot(status => {
				//eslint-disable-next-line no-unused-vars
				let source = status.metadata.hasPendingWrites ? 'Local' : 'Server'
          if (status && status.data()) {
           
            this.sideLoaded=false
            console.log(status.data())
            const dbState=status.data()
            this.statusState=dbState
            this.$store.commit('conversations/SET_HANDHELD'
          , {dbState}
           )
           this.sideLoaded=true
            this.statusChange();
          }
     })
      }


  },
  mounted() {


console.log(this.statusState)
this.testr()
  
     
   },
  components: {
    Sidebar,
   // LottieAnimation
  },
  beforeDestroy() {
          Lottie.destroy(this.animName);

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#lottieWorldAnim svg {
    width: 100vw !important;
    height: auto !important;
}

h1.top-covering-title {
    top: 0vh !important;
    width: 100vw;
    background-color: #0e2332;
    height: 7vh;
    padding: 3vh 0 8vh;
    color: white !important;
    z-index: 1;
    text-align: center;
    text-transform: uppercase;
    font-weight: bolder;
    border-top: 10px solid #de1a21;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
  #lottieWorldAnim svg {
    /* I'm in worldhome */
    width: auto !important;
    height: 100vh !important;
}

#nav {
    width: 77vw !important;
    height: 29vh !important;
    bottom: -10vh !important;
    left: 13.5vw !important;
}

h1.top-covering-title {
    height: 20vh !important;
}

}


</style>
